import React from 'react';
import { ReactComponent as ProfilePic } from '../../assets/images/pro-pic.svg';

// styles
import './style.scss';

export default function About() {
  return (
    <div id="about">
      <div className="about-left">
        <h2 className="about-title">About Me</h2>
        <p className="about-me">
          I am a Web Developer living in Bangladesh. I am a student of 12th
          Grade and looking for an opportunity to start my professional career
          in this field and learn more from the experts. I have 3 years
          experience in this field. I have the vision to become an ReactNative
          developer in near future.
        </p>
      </div>
      <div className="about-right">
        <ProfilePic className="profile-pic-abt" />
      </div>
    </div>
  );
}
